<template>
  <div class="ma-10 associateProcedureBloc">
    <VAutocomplete
      ref="autocompleteRef"
      v-model="data.procedures"
      :label="$t('forms.labels.procedure')"
      :items="displayedProcedures"
      :rules="{ required: true }"
      :clearable="true"
      multiple
      outlined
      :loading="proceduresLoading"
      menuProps="height > 700 ?{ maxHeight: '300' } : { maxHeight: '100' }"
      :attach="height > 700 ? false : true"
      data-cy="associateProcedure-list"
      @search="search"
      @change="onChange"
    >
      <template #withInfiniteScroll>
        <div v-intersect="endIntersect" />
      </template>
    </VAutocomplete>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import { isEmpty } from 'lodash';

export default {
    components: {
        VAutocomplete,
    },
    props: {
        associatedProceduresIds: {
            type: Array,
            default: () => [],
        },
        clientId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            proceduresLoading: false,
            availableProcedures: [],
            data: {
                procedures: [],
            },
            height: 0,
            queryParams: { perPage: 25 },
            pagination: {},
        };
    },
    computed: {
        ...mapGetters([
            'lang',
            'teamMainLang',
        ]),
        displayedProcedures() {
            return this.availableProcedures.map(({ id, name, code }) => ({
                name: name[this.lang] ? `${name[this.lang]} [${code}]` : `${name[this.teamMainLang]} [${code}]`,
                id,
                disabled: this.associatedProceduresIds.includes(id),
            }));
        },
    },
    watch: {
        data: {
            handler() {
                this.$emit('sendData', this.data);
            },
            deep: true,
        },
    },
    async created() {
        await this.loadProcedures();
    },
    mounted() {
        this.height = window.innerHeight;
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        async loadProcedures() {
            if (isEmpty(this.pagination) || (this.pagination?.currentPage !== this.pagination?.page)) {
                this.proceduresLoading = true;
                const { data } = await this.$rq.getProcedures(this.queryParams);
                this.availableProcedures = [...this.availableProcedures, ...data.procedures];
                this.pagination = data.pagination;
                this.proceduresLoading = false;
            }
        },
        onResize() {
            this.height = window.innerHeight;
        },
        async search(search) {
            this.proceduresLoading = true;
            const { data } = await this.$rq.getProcedures({ search, pagination: false });
            this.availableProcedures = data.procedures;
            this.proceduresLoading = false;
        },
        async onChange(val) {
            // when change is clear, reset the vselect list
            if (!val || !val.length) {
                this.availableProcedures = [];
                this.queryParam = {};
                this.pagination = {};
                await this.loadProcedures();
            }
        },
        async endIntersect(_, __, isIntersecting) {
            this.elementDeployable();
            const condition = this.pagination.currentPage < this.pagination.totalPageCount;
            if (isIntersecting && condition) {
                this.queryParams.page = this.pagination.currentPage + 1;
                await this.loadProcedures();
                // access "v-autocomplete" ref
                const ref = this.$refs?.autocompleteRef?.$refs?.autocomplete;
                if (ref?.onScroll) {
                // workaround to refresh list after adding new items.
                    ref.onScroll();
                }
            }
        },
        elementDeployable() {
            const verificationElement = document.querySelector('.associateProcedureBloc');
            if (verificationElement && document.querySelector('.menuable__content__active')) {
                document.querySelector('.menuable__content__active').style.width = '1px';
            }
        },
    },
};
</script>
